import {
  createGetServerSideProps,
  createTemplatePage,
  Props,
} from '../common-components/contentful-elements/pages/template';
import withErrorPage from '../common-components/component-library/infrastructure/withErrorPage';
import { PageContext } from '../utils/helpers/next';
import { getLocale } from '../utils/locales';

const _TopLevelPage = createTemplatePage({ campaignName: 'top-level-page' });
const TopLevelPage = withErrorPage(_TopLevelPage);

TopLevelPage.getInitialProps = async (ctx: PageContext): Promise<Props> => {
  const { query, req, asPath } = ctx;
  const name: string = query.name as string;
  const locale = getLocale(req, asPath);
  const { props: contentfulProps } = await createGetServerSideProps(name, ['Top level'], locale)();
  return contentfulProps;
};

export default TopLevelPage;
